<md-dialog>
	<div md-dialog-header>
		<md-icon icon="untitled-ui/general/check-done-02"></md-icon>
		<span class="md-text-lg-semibold">Review & Save Lesson</span>
	</div>

	<div class="dialog-content">
		@if (showDetailSections()) {
			<p class="md-text-sm-regular dialog-description">Review the lesson details below before saving.</p>

			<!-- Grades Section -->
			@if (hasGrades()) {
				<div class="review-section">
					<span class="review-section__label">Grades</span>
					<div class="review-section__content grades-grid">
						@for (item of gradeItems(); track item.categoryName) {
							<div class="grade-cell">
								<span class="grade-cell__category">
									{{ item.categoryName }}
								</span>
								@if (item.gradeName) {
									<lb-grade-tag [grade]="item.gradeName" [type]="item.gradeColor"></lb-grade-tag>
								} @else {
									<span class="grade-cell__empty">—</span>
								}
							</div>
						}
					</div>
				</div>
			}

			<!-- No Homework Grade Note -->
			@if (homeworkNoGrade()) {
				<div class="grade-info-note">
					<md-icon icon="untitled-ui/general/info-circle"></md-icon>
					<span class="md-text-sm-regular">No homework grade was recorded for this lesson.</span>
				</div>
			}

			<!-- Objectives Section -->
			@if (hasObjectives()) {
				<div class="review-section">
					<span class="review-section__label">Objectives</span>
					<div class="review-section__content objectives-tags">
						@for (objective of objectiveNames(); track objective) {
							<md-tag>{{ objective }}</md-tag>
						}
					</div>
				</div>
			}

			<!-- Project Progress Section -->
			@if (projectMilestoneName()) {
				<div class="review-section">
					<span class="review-section__label">Project Progress</span>
					<div class="review-section__content">
						<md-tag>{{ projectMilestoneName() }}</md-tag>
					</div>
				</div>
			}
		}

		<!-- Homework Categories Section -->
		@if (showHomeworkCategories()) {
			<div class="review-section">
				<span class="review-section__label">Homework</span>
				<div class="review-section__content objectives-tags">
					@for (category of homeworkCategories(); track category) {
						<md-tag>{{ category }}</md-tag>
					}
				</div>
			</div>
		}

		<!-- Attendance Section -->
		<div class="review-section">
			<span class="review-section__label"> Attendance </span>
			<div class="review-section__content">
				@if (isMultiAttendance()) {
					<md-tag type="success">{{ presentCount() }} present</md-tag>
					@if (absentCount() > 0) {
						<md-tag type="warning">{{ absentCount() }} absent</md-tag>
					}
				} @else {
					<md-tag type="success">Present</md-tag>
				}
			</div>

			@if (!isAttendanceTaken() && isAdmin()) {
				<label class="invoice-option">
					<input md-form-input type="checkbox" [checked]="generateInvoice()" (change)="generateInvoice.set($any($event.target).checked)" />
					<span class="md-text-sm-regular">Generate an invoice line item for this lesson.</span>
				</label>
			}
		</div>
	</div>

	<div md-dialog-footer>
		<button md-button (click)="close()">Cancel</button>
		<button md-button-brand (click)="confirm()">Save</button>
	</div>
</md-dialog>
